<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div id="app">
      <div class="content-wrapper">
        <div class="container-fluid">
          <img class="logo" :src="empresa.arquivo_logo" alt>
          <div class="box_general padding_bottom">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Digite o e-mail que será enviado uma nova senha</label>
                  <input type="text"
                    class="form-control"
                    placeholder="E-mail"
                    v-model="email"
                  >
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-center mt-2">
                <button class="btn_1 medium" type="button" @click="esqueceuSenha()">Enviar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajax, tratamento_requisicao, alerta } from "../../utils/util";
import funcoesGerais from "../../assets/js/funcoes.js";
import axios from "axios";
export default {
  mixins: [funcoesGerais],
  data: function() {
    return {
      email: "",
      isLoading: false,
      empresa: {
        arquivo_logo: ''
      },
      subUrl: ''
    };
  },
  created() {
    this.isLoading = true
    let subUrl = window.location.hostname
    this.subUrl = subUrl.split('.')

    axios.get(`show_by_subdominio/${this.subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.empresa = res.data
        this.empresa.arquivo_logo = axios.defaults.baseURL.slice(0, -3) + 'arquivos_logo/' + this.empresa.arquivo_logo
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  },
  methods: {
    esqueceuSenha() {
      let self = this;
      let subUrl = window.location.hostname
      subUrl = subUrl.split('.')

      if (self.email) {
        self.isLoading = true;
        ajax("put", "alterar_senha", {
          email: self.email,
          subdominio: subUrl[0]
        })
        .then(() => {
          self.isLoading = false;
          alerta('success','Sucesso!',"Sua nova senha será enviada para o seu e-mail!");
          self.$router.replace(self.$route.query.redirect || "/login");
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error);
        });
      } else {
        alerta('danger','Atenção',"Preencha o campo");
      }
      return false;
    }
  }
};
</script>
<style scoped>
.box_general {
  display: table;
  margin: 5% auto;
  width: 30%;
}
.content-wrapper {
  margin-left: 0px;
  background-color: #fff;
}
#exampleAccordion {
  display: none;
}
.logo {
  display: table;
  height: 250px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 20px;
}

body {
  background-color: #f8f8f8 !important;
}
</style>